module.exports = __webpack_public_path__ + "img/body-2-lg.c5351f74.png";